import React, { useEffect, useState } from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import useFetchData from '../../../../../../../../hooks/useFetchData'
import { useDispatch, useSelector } from 'react-redux'
import { updateFilter, showFilter } from '../../../../../../../../store/actions/filter.actions'
import { useLocation, useNavigate } from 'react-router-dom'
import isEmpty from 'lodash/isEmpty'
import InputField from '../../../../../../../FormControl/input/InputField'
import SelectMultipleField from '../../../../../../../FormControl/input/SelectMultipleField'
import { updateSkip } from '../../../../../../../../store/actions/datatable.actions'
import DialogConfirmCancel from '../../../../../../../dialog/DialogConfirm'
import AutocompleteField from '../../../../../../../FormControl/input/AutocompleteField'
import FormCurriculumElements from './FormCurriculumElements'

const FilterDialog = ({ type }) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const curriculum = useSelector((state) => state?.analytics?.analyticsCurriculum?.datasets?.curriculum || {})

  const date = useSelector((state) => state?.date?.date || new Date())
  const filter = useSelector((state) => state?.filter?.[type]?.filter || {})
  const open = useSelector((state) => state?.filter?.[type]?.open || false)
  const dataYears = useSelector((state) => state?.tenant?.years || [])
  const subjects = useSelector((state) => state?.subject?.list || [])

  const dispatch = useDispatch()

  const [form, setInputForm] = useState(filter)
  const [error, setInputError] = useState({})
  const [optionsSubjects, setOptionsSubjects] = useState([])

  useEffect(() => {
    const newOptionsSubjects =
      subjects
        ?.filter((s) => {
          if (isEmpty(form?.curriculumElements)) return true
          if (form?.curriculumElements?.elementId?.value && !form?.curriculumElements?.subElementId?.value) {
            return form?.curriculumElements?.elementId?.value.includes(s.curriculumelements?.elementId?.value)
          }
          if (!form?.curriculumElements?.elementId?.value && form?.curriculumElements?.subElementId?.value) {
            return form?.curriculumElements?.subElementId?.value.includes(
              s.curriculumelements?.subElementId?.value
            )
          }

          if (form?.curriculumElements?.elementId?.value && form?.curriculumElements?.subElementId?.value) {
            return (
              form?.curriculumElements?.elementId?.value.includes(s.curriculumelements?.elementId?.value) &&
              form?.curriculumElements?.subElementId?.value.includes(
                s.curriculumelements?.subElementId?.value
              )
            )
          }

          return true
        })
        ?.map((item) => ({ value: item._id, label: item.name })) || []
    setOptionsSubjects(newOptionsSubjects)
  }, [subjects, form?.curriculumElements])
  useEffect(() => {
    if (!isEmpty(filter)) {
      setInputForm(filter)
    }
  }, [filter])

  const onClose = () => {
    dispatch(showFilter(type, false))
  }

  const onChange = (name, value) => {
    if (name === 'yearLevelId') {
      setInputError({ ...error, [name]: null, yearLevel: null })
      const yearLevel = dataYears.filter((item) => value.includes(item._id))
      const yearLevel_name = dataYears
        .filter((year) => value.includes(year._id))
        .map((year) => ({ _id: year._id, name: year.name }))
      setInputForm({ ...form, [name]: value, yearLevel, yearLevel_name })
    } else if (name === 'curriculumElements') {
      setInputForm({ ...form, [name]: value, subject: null, subjectId: null, subjectId_name: null })
    } else if (name === 'subjectId') {
      setInputForm({ ...form, subject: value, [name]: value.value, subjectId_name: value.label })
    } else {
      setInputForm({ ...form, [name]: value })
      setInputError({ ...error, [name]: null })
    }
  }

  const onApply = () => {
    onClose()
    const filter = {
      ...form,
      yearLevelId: form.yearLevelId || [],
      yearLevel_name: form.yearLevel_name || [],
      yearLevel: form.yearLevelId || []
    }

    dispatch(updateFilter(type, filter))
    dispatch(updateSkip(type, 0))
    navigate(pathname, { state: filter })
  }

  return (
    <DialogConfirmCancel
      id='dialog-filter-users-class-student-selector'
      open={open}
      title='Filter'
      maxWidth='xs'
      onCancel={onClose}
      onConfirm={onApply}
      textConfirm='Apply'
    >
      <Box className='flex flex-col gap-4'>
        <div className='grid grid-cols-3 items-center gap-4'>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            Code
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-code'
              name='code'
              value={form.code}
              error={error.code}
              helperText={error.code}
              maxDate={date}
              onChange={(e) => onChange('code', e.target.value)}
            />
          </div>
          {type === 'analyticsUsers' && (
            <>
              <Typography
                variant='inherit'
                className='font-bold capitalize'
                color='primary'
                align='right'
                component='p'
              >
                first name
              </Typography>
              <div className='col-span-2'>
                <InputField
                  id='form-filter-first-name'
                  name='firstName'
                  value={form.firstName}
                  error={error.firstName}
                  helperText={error.firstName}
                  maxDate={date}
                  onChange={(e) => onChange('firstName', e.target.value)}
                />
              </div>
              <Typography
                variant='inherit'
                className='font-bold capitalize'
                color='primary'
                align='right'
                component='p'
              >
                last name
              </Typography>
              <div className='col-span-2'>
                <InputField
                  id='form-filter-last-name'
                  name='lastName'
                  value={form.lastName}
                  error={error.lastName}
                  helperText={error.lastName}
                  maxDate={date}
                  onChange={(e) => onChange('lastName', e.target.value)}
                />
              </div>
            </>
          )}

          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            year level
          </Typography>
          <div className='col-span-2'>
            <SelectMultipleField
              id='form-filter-year-level'
              name='yearLevelId'
              value={form.yearLevelId}
              error={error.yearLevelId}
              helperText={error.yearLevelId}
              onChange={(e) => onChange('yearLevelId', e.target.value)}
              options={dataYears?.map((item) => ({ value: item._id, label: item.name })) || []}
              placeholder='Choose a year level'
            />
          </div>

          {/*type === 'analyticsUsers' && (
            <>
              <Typography
                variant='inherit'
                className='font-bold capitalize'
                color='primary'
                align='right'
                component='p'
              >
                form
              </Typography>
              <div className='col-span-2'>
                <InputField
                  id='form-filter-form'
                  name='form'
                  value={form.form}
                  error={error.form}
                  helperText={error.form}
                  maxDate={date}
                  onChange={(e) => onChange('form', e.target.value)}
                />
              </div>
              <Typography
                variant='inherit'
                className='font-bold capitalize'
                color='primary'
                align='right'
                component='p'
              >
                house
              </Typography>
              <div className='col-span-2'>
                <InputField
                  id='form-filter-house'
                  name='house'
                  value={form.house}
                  error={error.house}
                  helperText={error.house}
                  maxDate={date}
                  onChange={(e) => onChange('house', e.target.value)}
                />
              </div>
            </>
          )}*/}
          {type === 'analyticsClasses' && (
            <>
              <FormCurriculumElements
                formData={form.curriculumElements || {}}
                onChangeAlert={onChange}
                currentCurriculum={curriculum}
              />
              <Typography
                variant='inherit'
                className='font-bold capitalize'
                color='primary'
                align='right'
                component='p'
              >
                Subject
              </Typography>
              <div className='col-span-2'>
                <AutocompleteField
                  id='subjectId'
                  name='subjectId'
                  value={form.subject || ''}
                  onChange={(value) => onChange('subjectId', value)}
                  options={optionsSubjects}
                  placeholder='Choose an option'
                />
              </div>
            </>
          )}
        </div>
      </Box>
    </DialogConfirmCancel>
  )
}

export default FilterDialog
